/**
 * Logic for managing the Connatix Video Player Script
 * Also handles how the video player is injected
 * onto the page/in the DOM.
 *
 * This class should be instantiated from a specific child theme bundle.
 * DO NOT instantiate this class in any main.js files.
 * It will slow down pages significantly.
 *
 * This class is pulled into separate child-theme bundles so it can be
 * enqueued on specific templates and themes via PHP.
 */

class ConnatixVideoPlayer {
  /**
   * ConnatixVideoPlayer Constructor
   *
   * @param cId - connatix player Id
   * @param scriptId - script player element ID
   * @param token - connatix player token
   * @param type - type of player to load, alters script slightly
   */
  constructor(cId, scriptId, token, playerType = 'elements') {
    this.cId = cId;
    this.scriptId = scriptId;
    this.token = token;
    this.playerType = playerType;
  }

  /**
   * Initialize the video player
   * Should be called from within a window event listener
   * "load" or "DOMContentLoaded"
   *
   * @return void
   */
  init() {
    console.log('Injecting Connatix Video Script');
    this.connatixScript(document);
  }

  /**
   * Connatix JS script
   * Code provided by Connatix, modified for this class.
   *
   * @param n - document object
   * @return void
   */
  connatixScript(n) {
    let cId = this.cId;

    if (this.playerType === 'elements') {
      if (!window.cnx) {
        (window.cnx = {}), (window.cnx.cmd = []);
        var t = n.createElement('iframe');
        t.src = 'javascript:false';
        (t.display = 'none'),
          (t.onload = function () {
            var n = t.contentWindow.document,
              c = n.createElement('script');
            (c.src = '//cd.connatix.com/connatix.player.js?cid=' + cId),
              c.setAttribute('async', '1'),
              c.setAttribute('type', 'text/javascript'),
              n.body.appendChild(c);
          }),
          n.head.appendChild(t);
      }
    } else if (this.playerType === 'playspace') {
      if (!window.cnxps) {
        (window.cnxps = {}), (window.cnxps.cmd = []);
        var t = n.createElement('iframe');
        t.src = 'javascript:false';
        (t.display = 'none'),
          (t.onload = function () {
            var n = t.contentWindow.document,
              c = n.createElement('script');
            (c.src = '//cd.connatix.com/connatix.playspace.js?cid=' + cId),
              c.setAttribute('async', '1'),
              c.setAttribute('type', 'text/javascript'),
              n.body.appendChild(c);
          }),
          n.head.appendChild(t);
      }
    }

    this.injectConnatixVideoPlayer(this.playerType);
  }

  /**
   * Inject the video player.
   * Inserts the Connatix script after the 2nd paragraph tag.
   * Targets the main post article body.
   *
   * @return void
   */
  injectConnatixVideoPlayer(playerType) {
    console.log('Injecting Connatix Video Player');

    const articleBody = document.querySelector('article.content, article div.text-box');

    if (articleBody) {
      // create the script element that needs to be injected in the post body
      const connatixPlayerScript = document.createElement('script');
      connatixPlayerScript.type = 'text/javascript';
      connatixPlayerScript.id = this.scriptId;

      // script contents - provided by connatix.
      // site-specific values for token, cId, scriptId pass on instantiation of this class
      // there are two player types with slightly different script values, as seen below ("cnx" vs "cnxps")
      let connatixPlayerScriptContents = '';

      if (playerType === 'playspace') {
        connatixPlayerScriptContents =
          '(new Image()).src = "https://capi.connatix.com/tr/si?token=' +
          this.token +
          '&cid=' +
          this.cId +
          '";  cnxps.cmd.push(function() {    cnxps({      playerId: "' +
          this.token +
          '"    }).render("' +
          this.scriptId +
          '");  });';
      } else {
        connatixPlayerScriptContents =
          '(new Image()).src = "https://capi.connatix.com/tr/si?token=' +
          this.token +
          '&cid=' +
          this.cId +
          '";  cnx.cmd.push(function() {    cnx({      playerId: "' +
          this.token +
          '"    }).render("' +
          this.scriptId +
          '");  });';
      }

      // inject the script element after the second paragraph in the post body
      const paragraphs = articleBody.querySelectorAll('p');

      if (paragraphs && paragraphs[1]) {
        const videoContainer = document.createElement('aside');
        videoContainer.style.margin = '15px 0';
        videoContainer.classList.add('connatix-video-player', 'ad-space', 'hidden-on-mobile');

        if (videoContainer) {
          try {
            // fill the script element with JS to run
            connatixPlayerScript.appendChild(document.createTextNode(connatixPlayerScriptContents));
            videoContainer.appendChild(connatixPlayerScript);
            paragraphs[1].append(videoContainer);
          } catch (e) {
            console.error('Could not inject Connatix Video Player');
          }
        }
      }
    }
  }
}

export { ConnatixVideoPlayer };
